module.exports = "/assets/data/e4fe64cac57890c1448fca81f3549332-HG5.data.json";